'use strict';

var React = require('react');
var styled = require('styled-components');
var palette = require('../../../theme/palette.js');
var component = require('../../Text/component.js');

function _interopDefaultCompat (e) { return e && typeof e === 'object' && 'default' in e ? e : { default: e }; }

var React__default = /*#__PURE__*/_interopDefaultCompat(React);
var styled__default = /*#__PURE__*/_interopDefaultCompat(styled);

const Caption = React.forwardRef(({ ...props }, ref) => (React__default.default.createElement(component.Text, { ...props, ref: ref, variant: "caption" })));
const colorByIntent = (intent) => {
    switch (intent) {
        case 'danger':
            return palette.textColors.danger;
        case 'help':
        default:
            return palette.textColors.disabled;
    }
};
const StyledCaption = styled__default.default(Caption) `
  display: block;
  color: ${({ intent }) => colorByIntent(intent)};
`;
const Styled = {
    Caption: StyledCaption,
};

exports.Styled = Styled;
//# sourceMappingURL=styles.js.map
